// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteAdmin-FormDefinitionConfig-SelectableFormFieldOverlay-module-componentOverlay {
	padding: 4px;
	position: relative;
	z-index: 4;
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFieldOverlay-module-componentOverlay:hover {
	background-color: var(--Grey200);
	border-radius: 4px;
	outline: var(--StandardBorder);
}
`, "",{"version":3,"sources":["webpack://./src/SiteAdmin/FormDefinitionConfig/SelectableFormFieldOverlay.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,gCAAgC;CAChC,kBAAkB;CAClB,8BAA8B;AAC/B","sourcesContent":[".componentOverlay {\n\tpadding: 4px;\n\tposition: relative;\n\tz-index: 4;\n}\n\n.componentOverlay:hover {\n\tbackground-color: var(--Grey200);\n\tborder-radius: 4px;\n\toutline: var(--StandardBorder);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"componentOverlay": `SiteAdmin-FormDefinitionConfig-SelectableFormFieldOverlay-module-componentOverlay`
};
module.exports = ___CSS_LOADER_EXPORT___;
